module.exports = __webpack_public_path__ + "static/media/about-us1.37bb1ed0.png";